import React from 'react';

const AllowanceInfo = ({ allowances }) => {
    const voiceAllowance = allowances?.find(a => a.type === "VOICE");
    const smsAllowance = allowances?.find(a => a.type === "SMS");

    const getVoiceValue = () => {
        if (voiceAllowance) {
            if (voiceAllowance.unlimited) return "Unlimited";
            return voiceAllowance.amount > 0 ? `${voiceAllowance.amount} ${voiceAllowance.unit || 'Mins'}` : "N/A";
        }
        return "N/A";
    };

    const getSmsValue = () => {
        if (smsAllowance) {
            if (smsAllowance.unlimited) return "Unlimited";
            return smsAllowance.amount > 0 ? `${smsAllowance.amount} ${smsAllowance.unit || 'SMS'}` : "N/A";
        }
        return "N/A";
    };

    const hasVoice = voiceAllowance && (voiceAllowance.unlimited || voiceAllowance.amount > 0);
    const hasSms = smsAllowance && (smsAllowance.unlimited || smsAllowance.amount > 0);

    if (!hasVoice && !hasSms) {
        return null;
    }

    return (
        <div className="bundle-allowance-inline">
            <div className="allowance-items">
                
                <span className="allowance-item">
                    <i className="pi pi-phone mr-1"></i>Voice: {getVoiceValue()}
                </span>
                <span className="allowance-sep"> | </span>
                <span className="allowance-item">
                    <i className="pi pi-comment mr-1"></i>SMS: {getSmsValue()}
                </span>
            </div>
        </div>
    );
};

export default AllowanceInfo;
